import { FC, useEffect, useMemo } from 'react'
import { Form, Formik } from 'formik'
import * as Yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'

import { Button } from '@src/components/Button/Button'
import { ReactComponent as Loupe } from '@src/assets/loupe.svg'
import style from '@src/pages/MovingNewAddress/MovingNewAddress.module.scss'
import { validateForm } from '@src/messages/validateForm'
import { FieldFormik } from '@src/components/common/FieldFormik/FieldFormik'
import { AppDispatch } from '@src/store/store'
import { selectAddressIsLoadingCheck, selectMovingNewAddress } from '@src/store/ducks/address/selectors'
import { getAddresses, postCheckAddress } from '@src/store/ducks/address/thunks'
import { SelectFormik } from '@src/components/common/Select/SelectFormik'

type MovingNewAddressFormProps = {
  setIsOpenModal: (value: boolean) => void
  formRef: any
}

export const MovingNewAddressForm: FC<MovingNewAddressFormProps> = ({ setIsOpenModal, formRef }) => {
  const dispatch = useDispatch<AppDispatch>()
  const addresses = useSelector(selectMovingNewAddress)
  const isLoadingCheck = useSelector(selectAddressIsLoadingCheck)

  useEffect(() => {
    dispatch(getAddresses())
  }, [dispatch])

  const validationSchema = useMemo(() => (
    Yup.object().shape({
      street: Yup.object().nullable().required(validateForm.required),
      house: Yup.string().required(validateForm.required),
      corpus: Yup.string(),
    })
  ), [])

  const initialValues = useMemo(() => ({
    corpus: '',
    street: null as null | { value: string, label: string },
    house: '',
  }), [])

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={({
        corpus, house, street,
      }) => {
        dispatch(postCheckAddress(corpus, house, street?.value, setIsOpenModal))
      }}
      validationSchema={validationSchema}
      innerRef={formRef}
    >
      <Form>
        <div className={style.box_1}>
          <SelectFormik
            options={addresses.map((item) => ({ value: item, label: item }))}
            placeholder="Название улицы"
            label="Укажите адрес"
            className={style.inputSizeLabel}
            text="Введите другое название улицы"
            name="street"
            type="input"
          />
          <div className={style.homeBlock}>
            <div className={style.home}>
              <FieldFormik
                placeholder="158"
                name="house"
                label="№ Дома"
                className={style.inputSize}
              />
            </div>
            <div className={style.shell}>
              <FieldFormik
                placeholder="4"
                name="corpus"
                label="№ Корпуса"
                className={style.inputSize}
              />
            </div>
          </div>
        </div>
        <div className={`${style.btn}`}>
          <Button
            type="primary"
            className={style.btnSize}
            htmlType="submit"
            icon={<Loupe />}
            loading={isLoadingCheck}
          >
            Проверить адрес
          </Button>

        </div>
      </Form>
    </Formik>
  )
}
